import { render, staticRenderFns } from "./SaleConfirmationToAston.vue?vue&type=template&id=86b7415a&scoped=true&"
import script from "./SaleConfirmationToAston.vue?vue&type=script&lang=js&"
export * from "./SaleConfirmationToAston.vue?vue&type=script&lang=js&"
import style0 from "./SaleConfirmationToAston.vue?vue&type=style&index=0&id=86b7415a&scoped=true&lang=css&"
import style1 from "./SaleConfirmationToAston.vue?vue&type=style&index=1&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b7415a",
  null
  
)

export default component.exports